module.exports = __webpack_public_path__ + "img/google_play.506b4053.svg";